'use client';
import React from 'react';
import { motion } from 'framer-motion';

export const FadeIn = ({ children, className }: { className?: string; children: React.ReactNode }) => {
  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 10,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      transition={{
        duration: 1,
        ease: 'easeInOut',
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};
